/*
 * ZAYOR — Cadeaux automatiques.
 *
 * Réconcilie les lignes cadeaux du panier après chaque changement.
 * Le thème émet `cart:updated` sur `document` et réagit à `cart:refresh`,
 * ce qui suffit à recalculer sans toucher au code Kalles.
 *
 * Règles, dans l'ordre :
 *   1. un duo dans le panier      -> Bandeau + Gant
 *   2. sinon un gommage           -> Gant de gommage
 *   3. sinon au moins un article  -> Pince à cheveux
 *   4. et, cumulable, total >= seuil -> Trousse + brosse
 */
(function () {
  'use strict';

  var node = document.getElementById('zayor-gifts-config');
  if (!node) return;

  var CFG;
  try {
    CFG = JSON.parse(node.textContent);
  } catch (e) {
    return;
  }
  if (!CFG || !CFG.enabled) return;

  var GIFT_IDS = [CFG.gifts.trousse, CFG.gifts.gant, CFG.gifts.bandeau, CFG.gifts.pince]
    .map(Number)
    .filter(function (id) { return id > 0; });

  if (!GIFT_IDS.length) return;

  var JSON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  };

  var busy = false;
  var pending = null;

  function isGift(variantId) {
    return GIFT_IDS.indexOf(Number(variantId)) !== -1;
  }

  /* Les cadeaux valent 0 €, mais on somme les lignes payantes pour rester
     juste même si un cadeau venait à être facturé par erreur. */
  function wantedGifts(cart) {
    var paid = cart.items.filter(function (line) { return !isGift(line.variant_id); });
    if (!paid.length) return [];

    var handles = paid.map(function (line) { return line.handle; });
    var contains = function (list) {
      return handles.some(function (handle) { return list.indexOf(handle) !== -1; });
    };

    var wanted = [];
    if (contains(CFG.duoHandles)) {
      wanted.push(CFG.gifts.bandeau);
    } else if (contains(CFG.gommageHandles)) {
      wanted.push(CFG.gifts.gant);
    } else {
      wanted.push(CFG.gifts.pince);
    }

    var total = paid.reduce(function (sum, line) { return sum + line.final_line_price; }, 0);
    if (total >= CFG.threshold) wanted.push(CFG.gifts.trousse);

    return wanted.map(Number).filter(function (id) { return id > 0; });
  }

  function group(digits, separator) {
    return digits.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  }

  /* Reproduit le money_format de la boutique côté client. */
  function money(cents) {
    var build = function (decimalSep, thousandSep, decimals) {
      var parts = (cents / 100).toFixed(decimals).split('.');
      var out = group(parts[0], thousandSep);
      if (decimals && parts[1]) out += decimalSep + parts[1];
      return out;
    };
    return (CFG.moneyFormat || '{{amount}}')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, build(',', '.', 2))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, build(',', '.', 0))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, build('.', ',', 0))
      .replace(/\{\{\s*amount\s*\}\}/g, build('.', ',', 2));
  }

  /* Kalles ne re-rend que [data-cart-items] et [data-cart-prices] :
     le bloc avantages vit en dehors, il doit se repeindre lui-même.
     La logique reproduit exactement celle de zayor-gifts-bar.liquid. */
  function paintBar(cart) {
    var blocks = document.querySelectorAll('[data-zayor-rewards]');
    if (!blocks.length) return;

    var total = cart.items.reduce(function (sum, line) {
      return isGift(line.variant_id) ? sum : sum + line.final_line_price;
    }, 0);

    var ship = CFG.shippingThreshold;
    var gift = CFG.threshold;
    var max = Math.max(ship, gift);
    var percent = Math.min(100, Math.round((total * 100) / max));

    var shipDone = total >= ship;
    var giftDone = total >= gift;
    var texts = CFG.texts || {};
    var state = 'is-progress';
    var message;

    if (shipDone && giftDone) {
      state = 'is-complete';
      message = texts.success || '';
    } else if (!shipDone && ship <= gift) {
      message = (texts.shipping || '').replace('[remaining]', money(ship - total));
    } else {
      message = (texts.progress || '').replace('[remaining]', money(gift - total));
    }

    Array.prototype.forEach.call(blocks, function (block) {
      block.classList.remove('is-progress', 'is-complete');
      block.classList.add(state);
      block.setAttribute('data-percent', percent);

      var text = block.querySelector('[data-zayor-rewards-text]');
      if (text && message) text.textContent = message;

      var fill = block.querySelector('[data-zayor-rewards-fill]');
      if (fill) fill.style.width = percent + '%';

      var steps = block.querySelectorAll('[data-zayor-rewards-step]');
      Array.prototype.forEach.call(steps, function (step) {
        var done = step.getAttribute('data-zayor-rewards-step') === 'shipping' ? shipDone : giftDone;
        step.classList.toggle('is-done', done);
      });
    });
  }

  function post(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: JSON_HEADERS,
      body: JSON.stringify(payload)
    });
  }

  function reconcile() {
    if (busy) {
      pending = true;
      return;
    }
    busy = true;

    fetch(CFG.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        paintBar(cart);

        var wanted = wantedGifts(cart);
        var present = cart.items.filter(function (line) { return isGift(line.variant_id); });

        var updates = {};
        var additions = [];

        /* Retire les cadeaux non mérités et ramène les autres à 1. */
        present.forEach(function (line) {
          var target = wanted.indexOf(Number(line.variant_id)) !== -1 ? 1 : 0;
          if (line.quantity !== target) updates[line.variant_id] = target;
        });

        /* Ajoute ceux qui manquent. */
        wanted.forEach(function (id) {
          var already = present.some(function (line) { return Number(line.variant_id) === id; });
          if (!already) {
            additions.push({ id: id, quantity: 1, properties: { _zayor_cadeau: '1' } });
          }
        });

        var hasUpdates = Object.keys(updates).length > 0;
        if (!hasUpdates && !additions.length) return false;

        var chain = Promise.resolve();
        if (hasUpdates) {
          chain = chain.then(function () { return post(CFG.routes.update, { updates: updates }); });
        }
        if (additions.length) {
          chain = chain.then(function () { return post(CFG.routes.add, { items: additions }); });
        }
        return chain.then(function () { return true; });
      })
      .then(function (changed) {
        busy = false;
        if (changed) {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }
        if (pending) {
          pending = false;
          reconcile();
        }
      })
      .catch(function () {
        busy = false;
        pending = false;
      });
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(reconcile, 120);
  }

  document.addEventListener('cart:updated', schedule);

  /* Rattrape les paniers créés avant l'activation ou sur un autre appareil. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();
